import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Grid from '../../Grid';
import Input from '../../Input';
import Form from '../../Form';
import Popup from './../Popup';
import SaveChangesButton from '../../SaveChangeButtonPopup';
import s from '../Popup.css';
import Messages from '../Messages';
import cx from 'classnames';
import ConnectedDevicesSoftenerXSafeTech from './ConnectedDevicesSoftenerXSafeTech';

import {
  getDeviceInfo,
  saveInstallationData
} from '../../../actions/device'

class NewInstallationPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serial: null
    };
  }

  componentWillMount() {
    this.props.getDeviceInfo(this.props.serial, this.props.devicetype);
  }

  onClick = () => {
    let values = null;
    switch(this.props.devicetype){
      case 'softener':
      case 'charlie':
      case 'simplex':
        values = {
          serial: this.props.serial,
          softener_serial: this.props.serial,
          safetech_serial: this.state.serial,
        }
        break;
      case 'safetech':
        values = {
          serial: this.props.serial,
          safetech_serial: this.props.serial,
          softener_serial: this.state.serial,
        }
        break;
      default:
        break;
    }
    if (values){
      this.props.saveInstallationData(values);  
    }
  };

  onFieldChange = (field, e) => {
    this.setState({
      [field]: e,
    });
  };

  render() {
    const { intl, devicetype, serial, authentication, devicesList } = this.props;
    const userRole = authentication.get('userRole')
    const messages = Messages();
    const device = devicesList.find(item => item.get('serial') === serial);
    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        devicetype={devicetype}
        overrideOnClose
      >
        <div className={s.wrapper}>
          <div className={s.first}>
            <ConnectedDevicesSoftenerXSafeTech 
              device={device}
              userRole={userRole}
              serial={serial}
            />
          </div>
          <div className={s.second}>
            <Form onSubmit={this.onSubmit}>
              <Grid.Cell>
                <Input
                  type="text"
                  name="serial"
                  title={intl.formatMessage(
                    messages.serial_number_label_main_screen_text,
                  )}
                  onChange={this.onFieldChange.bind(this, 'serial')}
                  titleVisibility
                />
              </Grid.Cell>
             
              <SaveChangesButton devicetype={devicetype} onClick={this.onClick} />
            </Form>
          </div>
        </div>
       
      </Popup>
    );
  }
}

NewInstallationPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  saveInstallationData: PropTypes.func.isRequired,
  getDeviceInfo: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  serial: PropTypes.string.isRequired,
  devicetype: PropTypes.string,
};

NewInstallationPopup.defaultProps = {
  devicetype: '',
};

const mapState = state => ({
  devicesList: state.deviceList,
  authentication: state.authentication,
});

const mapDispatch = dispatch => {
  return {
    saveInstallationData: (data) => dispatch(saveInstallationData(data)),
    getDeviceInfo: (deviceId, deviceType) =>
      dispatch(getDeviceInfo(deviceId, deviceType)),
  };
};

export default injectIntl(
  compose(connect(mapState, mapDispatch), withStyles(s))
  (NewInstallationPopup)
);



// WEBPACK FOOTER //
// ./src/components/Popup/DevicePopups/NewInstallationPopUp.js